import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, InputSignal, input } from '@angular/core';

import { Mapper, MapperPipe } from 'tiime-expert-utils';
import {
  FallbackTextDirective,
  TiimeIconModule,
  TiimeIconPropertyDirective,
  TiimePropertiesDirective,
  TiimePropertyDirective
} from 'tiime-material';

import { ContractStatus } from '@gi/enums/contract-status.enum';
import { Contract } from '@gi/models/contract';
import { Prospect } from '@gi/models/prospect';
import { PhonePipe } from '@shared-pipes/phone/phone.pipe';

@Component({
  selector: 'app-duplicated-prospects-container',
  standalone: true,
  imports: [
    CommonModule,
    TiimeIconModule,
    TiimePropertiesDirective,
    TiimePropertyDirective,
    TiimeIconPropertyDirective,
    FallbackTextDirective,
    PhonePipe,
    MapperPipe
  ],
  templateUrl: './duplicated-prospects-container.component.html',
  styleUrls: ['./duplicated-prospects-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DuplicatedProspectsContainerComponent {
  readonly duplicatedProspects: InputSignal<Prospect[]> = input.required<Prospect[]>();

  readonly mapToSignedContracts: Mapper<Contract[], number> = (contacts: Contract[]) =>
    contacts.filter((contract: Contract) => contract.status === ContractStatus.signed)?.length ?? 0;
}
